import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.'

@vsingleton()
export class AdminVipGroupRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'vip-groups.'

  index() {
    return this.ziggyRoute('index')
  }

  show(id: number) {
    return this.ziggyRoute('show', id)
  }

  // create() {
  //   return this.ziggyRoute('create')
  // }
  //
  store() {
    return this.ziggyRoute('store')
  }

  update(id: number) {
    return this.ziggyRoute('update', id)
  }

  destroy(id: number) {
    return this.ziggyRoute('destroy', id)
  }

}
